import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { StoryblokCountdownComponent } from '../../app/content/modules/storyblok/components/storyblok-countdown/storyblok-countdown.component';
import { withStoryblokDecorators } from '../_utils/story-helpers';
import dayjs from 'dayjs';

function futureDate(days: number, hours = 0): string {
  return dayjs().add(days, 'day').add(hours, 'hour').toISOString();
}

const meta: Meta<StoryblokCountdownComponent> = {
  title: 'Storyblok/Countdown',
  component: StoryblokCountdownComponent,
  decorators: [...withStoryblokDecorators()],
  parameters: {
    docs: {
      description: {
        component: 'Storyblok countdown timer component. Displays a live countdown to a target date/time.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<StoryblokCountdownComponent>;

export const Default: Story = {
  args: {
    countdown_datetime: futureDate(3, 12),
    title: 'Tilbud slutter om',
    _uid: 'sb-countdown-1',
    component: 'countdown',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-countdown')).toBeTruthy();
  },
};

export const ShowDays: Story = {
  args: {
    countdown_datetime: futureDate(7),
    title: 'Black Friday starter om',
    show_days: true,
    _uid: 'sb-countdown-2',
    component: 'countdown',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-countdown')).toBeTruthy();
  },
};

export const BoldFont: Story = {
  args: {
    countdown_datetime: futureDate(1),
    title: 'Flash sale!',
    font_weight: 700,
    _uid: 'sb-countdown-3',
    component: 'countdown',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-countdown')).toBeTruthy();
  },
};

export const WithColor: Story = {
  args: {
    countdown_datetime: futureDate(2, 6),
    title: 'Kampagnen udløber',
    color_theme: { value: '#E91E63' },
    _uid: 'sb-countdown-4',
    component: 'countdown',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-countdown')).toBeTruthy();
  },
};

export const Expired: Story = {
  args: {
    countdown_datetime: dayjs().subtract(1, 'day').toISOString(),
    title: 'Udløbet tilbud',
    _uid: 'sb-countdown-5',
    component: 'countdown',
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-countdown')).toBeTruthy();
  },
};
